module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzM2IiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAzNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ1MiAtMTYpIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfNDgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDQ4IiB3aWR0aD0iMTUiIGhlaWdodD0iNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUyIDIxLjUpIi8+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzQ5IiBkYXRhLW5hbWU9IumVt+aWueW9oiA0OSIgd2lkdGg9IjE1IiBoZWlnaHQ9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ2MS41IDE2KSByb3RhdGUoOTApIi8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_plus.svg
// module id = PKuV
// module chunks = 1